// extracted by mini-css-extract-plugin
export default {"badge":"ChatUnreadBadge_badge__zh9vE","pulse":"ChatUnreadBadge_pulse__zK9ls"};